import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { environment } from '../../../environments/environment';
import { MapService } from '../../services/map.service';
import { AddressService } from 'src/app/services/address.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.html',
  styleUrls: ['./map.scss']
})

export class MapComponent implements AfterViewInit {
  public destAddress: any;
  public driverLocation: any;
  public dynamicMap: boolean;
  public geocoder: any;
  public hideDynamicMap: boolean;
  public locations: any[];
  @ViewChild(GoogleMap) public map: GoogleMap;
  public mapInitTimeout: any;
  public markers: any[] = [];
  public options: any;
  public originAddress: any;
  public showNote: boolean;
  public staticMap: boolean;
  public staticMapUrl: string;
  public forceDraggable: boolean = false;

  constructor(private _mapService: MapService,
    private _cdRef: ChangeDetectorRef,
    private _addressService: AddressService) {

  }

  addMarker(marker) {
    const index = this.markers.findIndex((m) => m.title === marker.title);
    if (index === -1) {
      this.markers.push(marker);
    } else {
      this.markers[index] = marker;
    }
  }

  centerMap() {
    // If driver location and has lat and lon that is not 0 add driver marker before centering map
    if (this.driverLocation && this.driverLocation.latitude && this.driverLocation.longitude) {
      const marker = {
        map: this.map.googleMap,
        position: {
          lat: this.driverLocation.latitude,
          lng: this.driverLocation.longitude
        },
        title: 'DRIVER',
        options: {
          animation: google.maps.Animation.DROP,
          icon: '//maps.google.com/mapfiles/ms/micons/truck.png',
          draggable: this.forceDraggable
        }
      };
      this.addMarker(marker);
    }
    if (this.map) {
      const bounds = new google.maps.LatLngBounds();
      for (let i = 0; i < this.markers.length; i++) {
        if (this.markers[i]) {
          bounds.extend(this.markers[i].position);
        }
      }
      this.map.fitBounds(bounds);
    }
  }

  deleteAllMarkers() {
    this.markers = [];
    this._cdRef.detectChanges();
  }

  drawMap() {
    if (!this.dynamicMap) {
      console.log('Map Initializing');
      this.dynamicMap = true;
      this._cdRef.detectChanges();
      this.geocoder = new google.maps.Geocoder();
      this.removeMapTabIndexes();
      this.showRoute();
    } else {
      this.showRoute();
    }
  }

  geocodeAddress(point, type) {
    if (!point.lat || !point.lng) {
      if (point.fullAddress) {
        let addressToValidate = {
          street1: null,
          city: null,
          state: null,
          zip: null,
          country: null
        };
        if (point.fullAddressType !== 'city') {
          if (point.fullAddressType === 'complete') {
            let addressParts = point.fullAddress.split(',');
            if (addressParts.length === 5) {
              let addressParts = point.fullAddress.split(', ');
              addressToValidate.street1 = addressParts[0];
              addressToValidate.city = addressParts[1];
              addressToValidate.state = addressParts[2];
              addressToValidate.zip = addressParts[3];
              addressToValidate.country = point.validationCountry;
            } else {
              this.geocodePoint(point, type);
            }
          } else if (point.fullAddressType === 'zip') {
            addressToValidate.zip = point.fullAddress;
            addressToValidate.country = point.validationCountry;
          }
          this._addressService.validateAddress(addressToValidate.street1,
            addressToValidate.city,
            addressToValidate.state,
            addressToValidate.zip,
            addressToValidate.country).subscribe((response) => {
              if (response.validationResults && this.checkValidationResult(response, addressToValidate)) {
                const marker = {
                  map: this.map.googleMap,
                  position: {
                    lat: response.validationResults[0].geocode.latitude,
                    lng: response.validationResults[0].geocode.longitude
                  },
                  title: type,
                  options: {
                    draggable: point.draggable,
                    animation: google.maps.Animation.DROP
                  }
                };
                this.addMarker(marker);
                this.centerMap();
              } else { //validation failed
                this.geocodePoint(point, type);
              }
            });
        } else { //only the city was provided (we have the country, too, but that's still not enough to validate)
          this.geocodePoint(point, type);
        }
      } else { //no full address (not sure how this would happen but just in case)
        this.geocodePoint(point, type);
      }
    } else { //we have lat and lng already
      const marker = {
        map: this.map.googleMap,
        position: { lat: point.lat, lng: point.lng },
        title: type,
        options: {
          draggable: point.draggable,
          animation: google.maps.Animation.DROP
        }
      };
      this.addMarker(marker);
      this.centerMap();
    }
  }

  checkValidationResult(response, addressToValidate) {
    return (response.validationResults.length === 1 &&
      (
        response.validationResults[0].streetAddress1 === addressToValidate.street1 &&
        response.validationResults[0].city === addressToValidate.city &&
        response.validationResults[0].province === addressToValidate.state &&
        response.validationResults[0].postalCode === addressToValidate.zip &&
        response.validationResults[0].geocode &&
        response.validationResults[0].geocode.latitude &&
        response.validationResults[0].geocode.longitude
      )
    )
  }

  geocodePoint(point, type) {
    if (!this.geocoder)
      return;
    this.geocoder.geocode({ address: point.fullAddress }, (results, status) => {
      if (status === 'OK') {
        const marker = {
          map: this.map.googleMap,
          position: results[0].geometry.location,
          title: type,
          options: {
            draggable: point.draggable,
            animation: google.maps.Animation.DROP
          }
        };
        this.addMarker(marker);
        this.centerMap();
      } else {
        console.log(`Geocode was not successful for the following reason: ${status}`);
      }
    });
  }

  geocodeLatLng(event) {  //this is not currently called anywhere but if that changes, we may need to update the geocoder to try the address validation first
    this.geocoder.geocode({ location: event?.latLng }, (results, status) => {
      if (status === 'OK') {
        if (results[1]) {
          this._mapService.markerLocationChanged$.emit(results[0]);
        }
      } else {
        console.error('No workie')
      }
    });
  }

  getDefaultOptions() {
    return {
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.BOTTOM_LEFT
      },
      streetViewControl: false,
      mapTypeControl: false,
      scaleControl: false,
      scrollwheel: false,
      maxZoom: 20,
      minZoom: 2,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      forceDraggable: false,
    }
  }

  initMap() {
    if (window?.google) {
      this.options = this.getDefaultOptions();
      this._mapService.markerUpdated$.subscribe((locationObj) => {
        if (locationObj?.options) {
          this.options = { ...this.options, ...locationObj?.options };
        } else {
          this.options = this.getDefaultOptions();
        }
        if (locationObj?.zoom) {
          setTimeout(() => {
            this.map?.googleMap?.setZoom(locationObj?.zoom);
          }, 500);
        }
        this.hideDynamicMap = false;
        this.staticMap = false;
        this.staticMapUrl = null;
        switch (locationObj?.type) {
          case 'ORIGIN':
            this.originAddress = locationObj?.address;
            if (this.originAddress) {
              this.originAddress.draggable = locationObj?.draggable;
            }
            break;
          case 'DESTINATION':
            this.destAddress = locationObj?.address;
            break;
          case 'DRIVER':
            this.driverLocation = locationObj?.address;
            break;
          case 'STATIC':
            this.staticMap = true;
            this.dynamicMap = false;
            const channel = 'Rapidship-' + window.location.hostname;
            this.staticMapUrl = `//maps.googleapis.com/maps/api/staticmap?key=${environment.googleApiKey}&channel=${channel}`;
            this._cdRef.detectChanges();
            if (locationObj?.locations?.length > 0 && locationObj?.locations[0]?.lat && locationObj?.locations[0]?.lon) {
              const element = document.querySelector('#static-map') as any;
              let width = element.parentNode?.parentNode?.offsetWidth ?? 900
              let height = element.parentNode?.parentNode?.offsetHeight ?? 300
              if (height < 300) {
                height = 300
              }

              this.staticMapUrl = this.staticMapUrl.concat(`&size=${width}x${height}`);
              let hasMarkers = false;
              for (const i in locationObj?.locations) {
                if (locationObj?.locations[i]?.lat && locationObj?.locations[i]?.lon) {
                  hasMarkers = true;
                  this.staticMapUrl = this.staticMapUrl.concat(`&markers=${locationObj?.locations[i]?.lat},${locationObj?.locations[i]?.lon}`);
                }
              }
              if (hasMarkers) {
                element.src = this.staticMapUrl;
              } else {
                this.staticMapUrl = null;
              }
            } else {
              this.staticMapUrl = null;
            }
            break;
          case 'LOCATIONS':
            this.locations = locationObj?.address;
            break;
        }
        this.forceDraggable = this.options?.forceDraggable ?? false;
        this._cdRef.detectChanges();
        if (!this.map && locationObj?.address || this.map) {
          this.staticMap = false;
          this.drawMap();
        }
      });
    } else {
      setTimeout(() => {
        this.initMap();
      }, 1000);
    }
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  removeMapTabIndexes() {
    google.maps.event.addListener(this.map.googleMap, 'tilesloaded', function () {
      [].slice.apply(document.querySelectorAll(`#google-map a`)).forEach(item => {
        item.setAttribute('tabindex', '-1');
      });
      [].slice.apply(document.querySelectorAll(`#google-map iframe`)).forEach(item => {
        item.setAttribute('tabindex', '-1');
      });
    });
  }

  showRoute() {
    if (this.originAddress || this.destAddress || this.locations || this.driverLocation) {
      let origin = null;
      let destination = null;

      if (!this.originAddress?.draggable && (this.originAddress?.address1?.length > 0 || (this.originAddress?.lat && this.originAddress?.lon))) {
        origin = {
          address: this.originAddress.address1,
          title: this.originAddress.name,
          lat: this.originAddress.lat,
          lng: this.originAddress.lon,
          fullAddress: this.originAddress.address1 + ', ' + this.originAddress.city + ', ' + this.originAddress.state + ', ' + this.originAddress.zip + ', ' + (this.originAddress.country === 'US' ? 'USA' : 'Canada'),
          validationCountry: this.originAddress.country,
          fullAddressType: 'complete'
        };
      } else if (this.originAddress?.draggable) {
        origin = {
          title: this.originAddress.name,
          lat: this.originAddress.lat,
          lng: this.originAddress.lon,
          fullAddress: this.originAddress.zip ? this.originAddress.zip : this.originAddress.city,
          validationCountry: this.originAddress.country,
          fullAddressType: this.originAddress.zip ? 'zip' : 'city',
          draggable: true
        };
      }

      if (this.destAddress?.address1?.length > 0) {
        destination = {
          address: this.destAddress.address1,
          title: this.destAddress.name,
          lat: this.destAddress.lat,
          lng: this.destAddress.lon,
          fullAddress: this.destAddress.address1 + ', ' + this.destAddress.city + ', ' + this.destAddress.state + ', ' + this.destAddress.zip + ', ' + (this.destAddress.country === 'US' ? 'USA' : 'Canada'),
          validationCountry: this.destAddress.country,
          fullAddressType: 'complete'
        };
      }

      if (origin && destination) {
        if (origin.lat && origin.lng && destination.lat && destination.lng) {
          this.showNote = true;
          this._cdRef.detectChanges();
          this.deleteAllMarkers();
          const originMarker = {
            map: this.map.googleMap,
            position: { lat: origin.lat, lng: origin.lng },
            title: 'ORIGIN',
            options: {
              animation: google.maps.Animation.DROP
            }
          };
          this.addMarker(originMarker);
          const destinationMarker = {
            map: this.map.googleMap,
            position: { lat: destination.lat, lng: destination.lng },
            title: 'DESTINATION',
            options: {
              animation: google.maps.Animation.DROP
            }
          };
          this.addMarker(destinationMarker);
          this.centerMap();
        } else {
          this.geocodeAddress(origin, 'ORIGIN');
          this.geocodeAddress(destination, 'DESTINATION');
        }
      } else if (origin && !destination) {
        this.geocodeAddress(origin, 'ORIGIN');
      } else if (destination && !origin) {
        this.geocodeAddress(destination, 'DESTINATION');
      } else if (this.driverLocation) {
        this.centerMap();
      } else if (this.locations) {
        this.deleteAllMarkers();
        for (const address of this.locations) {
          if (address?.lat && address?.lon) {
            const marker = {
              map: this.map.googleMap,
              position: new google.maps.LatLng(address.lat, address.lon),
              title: address?.name,
              options: {
                animation: google.maps.Animation.DROP,
                draggable: this.forceDraggable,
              }
            };
            this.addMarker(marker);
          }
        }
        if (this.markers?.length > 0) {
          this.centerMap();
        } else {
          this.hideDynamicMap = true;
        }
      }
    } else {
      this.deleteAllMarkers();
      this.map?.googleMap?.setCenter({ lat: 39.8285013, lng: -98.5794589 });
      this.map?.googleMap?.setZoom(3);
    }
  }
}
